import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EVENTS as E } from '../../core/constants';
import { useSendEvents } from '../../core/hooks';
import { useCurrentLanguageItem } from '../../locales';
import { flagUrl } from '../../locales/languageConfig';
import { LanguageModal } from '../LanguageModal';
import * as S from './styled';

interface LanguagePickerProps {
  readonly screenId: string;
}

export const LanguagePicker = ({ screenId }: LanguagePickerProps) => {
  const { t } = useTranslation();
  const sendEvents = useSendEvents({ screenId });
  const { code, flagFile } = useCurrentLanguageItem();
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);

  const open = () => {
    sendEvents('header_language_picker__click', { [E.BC]: 'language_modal' });
    setIsOpen(true);
  };

  return (
    <>
      <S.LanguageChip
        type="button"
        onClick={open}
        aria-haspopup="dialog"
        aria-label={t('select_your_language')}
      >
        <S.LanguageFlag src={flagUrl(flagFile)} alt="" />
        {code}
      </S.LanguageChip>
      {isOpen && <LanguageModal onClose={close} screenId={screenId} />}
    </>
  );
};
